import { TooltipInfo } from "@/components/Icons";
import { chakra, Flex, Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { ReactNode } from "react";

interface VipInfoProps {
  title: string | ReactNode;
  btnText: string | ReactNode;
  info?: string | ReactNode;
  tooltip?: string | ReactNode;
  onBtnClick(): void;
}

function VipInfoCard(props: VipInfoProps) {
  const { title, btnText, info, onBtnClick, tooltip, ...other } = props;
  return (
    <Flex
      className="vip-info-card"
      bg="#404040"
      h="60px"
      flexGrow={1}
      w="100%"
      color="white"
      userSelect="none"
      align="center"
      rounded="4px"
      p="10px 14px"
      {...other}
    >
      <Flex h="100%" flexDir="column" flexGrow={1} justify="center">
        <Text fontSize="14px" fontWeight="600">
          {title}
        </Text>
        {info && (
          <Flex
            color="text.lightDisabled"
            fontSize="12px"
            transform="scale(0.83)"
            transformOrigin="left"
          >
            {info}
            {tooltip && (
              <TooltipInfo title="" info={tooltip} tooltipProps={{ placement: "bottom" }} />
            )}
          </Flex>
        )}
      </Flex>
      <Flex
        alignItems="center"
        justifyContent="center"
        w="50px"
        h="25px"
        fontSize="16px"
        rounded="full"
        fontWeight="600"
        pos="relative"
        cursor="pointer"
        onClick={onBtnClick}
        _before={{
          content: '""',
          position: "absolute",
          left: 0,
          top: 0,
          w: "100%",
          h: "100%",
          bg: "linear-gradient(270deg, #F0BF68 26.79%, #F9E5AE 132.14%)",
          rounded: "999px",
        }}
        _after={{
          content: '""',
          position: "absolute",
          left: 0,
          top: 0,
          w: "100%",
          h: "100%",
          bg: "#404040",
          border: "1px solid transparent",
          bgClip: "content-box",
          rounded: "999px",
        }}
      >
        <Text
          pos="relative"
          bg="linear-gradient(270deg, #F0BF68 26.79%, #F9E5AE 132.14%)"
          bgClip="text"
          fontSize="12px"
          zIndex={1}
        >
          {btnText}
        </Text>
      </Flex>
    </Flex>
  );
}

export default observer(chakra(VipInfoCard));
